var _circle, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.8921,
    r: 15.9,
    fill: "url(#paint0_linear_99_5)",
    stroke: "url(#paint1_linear_99_5)",
    strokeWidth: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 10.8921,
    width: 3,
    height: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18.3921,
    width: 3,
    height: 12,
    transform: "rotate(-90 10 18.3921)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_5",
    x1: 16,
    y1: 0.89209,
    x2: 16,
    y2: 32.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FEB0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179869",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_5",
    x1: 16,
    y1: 0.89209,
    x2: 16,
    y2: 32.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordPlus);
export default __webpack_public_path__ + "static/media/accord_plus.c34d42770e5fa2074f47ca93eeb9c3cf.svg";
export { ForwardRef as ReactComponent };